import React from 'react';

export const MedicarePartADescription = (
  <>
    <p>
      You’ll need to submit a copy of the beneficiary’s Original Medicare Health
      Part A card, sometimes called the “red, white, and blue” Medicare card.
    </p>
    <p>
      <strong>The card should include this information:</strong>
    </p>
    <ul>
      <li>
        Medicare Part A (listed as HOSPITAL), <strong>and</strong>
      </li>
      <li>The date coverage begins</li>
    </ul>
  </>
);

export const MedicarePartBDescription = (
  <>
    <p>
      You’ll need to submit a copy of the beneficiary’s Original Medicare Health
      Part B Card, sometimes referred to as the “red, white, and blue” Medicare
      card.
    </p>
    <p>
      <strong>The card should include this information:</strong>
    </p>
    <ul>
      <li>
        Medicare Part B (listed as MEDICAL), <strong>and</strong>
      </li>
      <li>The date coverage begins</li>
    </ul>
  </>
);

export const MedicarePartsAbDescription = (
  <>
    <p>
      You’ll need to submit a copy of the beneficiary’s Original Medicare Health
      Card, sometimes referred to as the “red, white, and blue” Medicare card.
    </p>
    <p>
      <strong>The card should include this information:</strong>
    </p>
    <ul>
      <li>
        Medicare Part A (listed as HOSPITAL), <strong>and</strong>
      </li>
      <li>
        Medicare Part B (listed as MEDICAL), <strong>and</strong>
      </li>
      <li>The date coverage begins</li>
    </ul>
  </>
);
